import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishAlert } from './alert';
import { FishAlertConfig } from './alert-config';

export { FishAlert } from './alert';
export { FishAlertConfig } from './alert-config';


export class FishAlertModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishAlertModule, providers: [FishAlertConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FishAlert],
  exports: [FishAlert],
  imports: [CommonModule],
  entryComponents: [FishAlert]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
